import { useBlockProps } from '@wordpress/block-editor';
import { __ } from "@wordpress/i18n";

export default function Save({ attributes }) {
    const {  } = attributes;

    return (
        <div
            {...useBlockProps.save({
            })}
        >
        </div>
    );
}
